import { render } from "./ApiMisc.vue?vue&type=template&id=42958668"
import script from "./ApiMisc.vue?vue&type=script&lang=js"
export * from "./ApiMisc.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Sveve\\www\\vue\\sveve.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__